var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-panel-wrapper p-1",class:{ 'shrunk': _vm.isSideBarOpen }},[_c('div',{staticClass:"main-panel h-100 shadow-lg rounded-xl"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }